import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { combineReducers } from "@reduxjs/toolkit";
import authenticationReducer from "../features/authentication/authenticationSlice";
import i18nReducer from "../features/localization/localizationSlice";
import sessionsReducer from "../features/sessions/sessions-slice";
import { injectStore } from "../features/axiosInstance/axiosInstance";

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  i18n: i18nReducer,
  sessions: sessionsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

injectStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
